<nav class="breadcrumbs" aria-label="Breadcrumb">
  <ol class="breadcrumbs__list">
    @for (item of items; track $index; let last = $last) {
      <li class="breadcrumbs__item">
        @if (item.click && !last) {
          <button
            type="button"
            class="breadcrumbs__link"
            (click)="item.click()"
          >
            {{ item.label }}
          </button>
        } @else {
          <span
            class="breadcrumbs__current"
            [attr.aria-current]="last ? 'page' : null"
          >
            {{ item.label }}
          </span>
        }
        @if (!last) {
          <mat-icon class="breadcrumbs__separator">chevron_right</mat-icon>
        }
      </li>
    }
  </ol>
</nav>
